import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { capitalizeFirstLetter, isBlank } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Toggle from "src/components/Toggle"

class PlaceholdersView extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      ...this.deriveStateFromProps(props),
    }
    this.savePlaceholder = this.savePlaceholder.bind(this)
    this.deletePlaceholder = this.deletePlaceholder.bind(this)
    this.spaceChange = this.spaceChange.bind(this)
    this.validator = validatorFactory({ autoForceUpdate: this })
  }

  deriveStateFromProps(props) {
    return {
      type: props.selectedPlaceholder.type,
      startDate:
        props.selectedPlaceholder.start_date &&
        moment(props.selectedPlaceholder.start_date),
      endDate:
        props.selectedPlaceholder.end_date &&
        moment(props.selectedPlaceholder.end_date),
      spaceId:
        props.selectedPlaceholder.space_id &&
        parseInt(props.selectedPlaceholder.space_id),
      spaceType: this.lookupSpaceType(props.selectedPlaceholder.space_id),
      note: props.selectedPlaceholder.note,
      isFlagged: !!props.selectedPlaceholder.is_flagged,
      length_overall: props.selectedPlaceholder.length_overall || "",
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedPlaceholder.id !== this.props.selectedPlaceholder.id ||
      prevProps.selectedPlaceholder.type !== this.props.selectedPlaceholder.type
    ) {
      this.setState(this.deriveStateFromProps(this.props))
    }
  }

  isNote() {
    return this.state.type === "note"
  }

  noteValidationValue() {
    return this.state.note && this.state.note.trim()
  }

  savePlaceholder() {
    if (this.props.comingFromMapView) {
      Amplitude.trackEvent(
        `assignments:map_view_add_${this.isNote() ? "note" : "placeholder"}`
      )
    } else {
      Amplitude.trackEvent(
        `assignments:add_${this.isNote() ? "note" : "placeholder"}`
      )
    }
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.setState({ saving: true })
      let params = {
        start_date: this.state.startDate.format("MM/DD/YYYY"),
        end_date: this.state.endDate.format("MM/DD/YYYY"),
        space_id: this.state.spaceId,
        note: this.state.note,
        length_overall: this.state.length_overall,
      }
      if (this.isNote()) {
        params.is_flagged = this.state.isFlagged
      }
      params = this.addIDToParams(params)
      const endpoint = this.isNote()
        ? $context.spaceNoteUpsertEndpoint
        : $context.placeholderUpsertEndpoint
      $.ajax({
        url: endpoint,
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(params),
        success: () => {
          this.props.reloadCurrentGrid(() => {
            this.setState({ saving: false })
            this.props.closeSidebar()
          })
        },
        error: (data) => {
          this.setState({ saving: false })
          const errorMessage =
            data.responseJSON.errors || "Unable to process, please try again"
          alert(errorMessage)
        },
      })
    }
  }

  deletePlaceholder() {
    this.setState({ deleting: true })
    const params = this.addIDToParams({})
    const endpoint = this.isNote()
      ? $context.spaceNoteDeleteEndpoint
      : $context.placeholderDeleteEndpoint
    $.ajax({
      url: endpoint,
      type: "POST",
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(params),
      success: () => {
        this.props.reloadCurrentGrid(() => {
          this.setState({ deleting: false })
          this.props.closeSidebar()
        })
      },
      error: (data) => {
        this.setState({ deleting: false })
        const errorMessage =
          data.responseJSON.errors || "Unable to process, please try again"
        alert(errorMessage)
      },
    })
  }

  addIDToParams(params) {
    if (this.isNote()) {
      params.space_note_id = this.props.selectedPlaceholder.id
    } else {
      params.placeholder_id = this.props.selectedPlaceholder.id
    }
    return params
  }

  spaceOptions() {
    return _.map(this.props.spacesBySpaceGroups, (spaceGroup) => {
      const sortedSpaces = spaceGroup.spaces.sort((a, b) => a.order - b.order)
      return (
        <optgroup
          key={`space-group-${spaceGroup.id}`}
          label={spaceGroup.name ? spaceGroup.name : "(no space group)"}
        >
          {_.map(sortedSpaces, (space) => (
            <option key={space.id} value={space.id}>
              {space.name}
            </option>
          ))}
        </optgroup>
      )
    })
  }

  spaceChange(event) {
    const newSpaceId = isBlank(event.target.value)
      ? null
      : parseInt(event.target.value)

    this.setState({
      spaceId: newSpaceId,
      spaceType: this.lookupSpaceType(newSpaceId),
    })
  }

  lookupSpaceType(spaceId) {
    if (!spaceId || !parseInt(spaceId)) {
      return null
    }

    spaceId = parseInt(spaceId)
    const spaceGroup = _.find(this.props.spacesBySpaceGroups, (sg) => {
      return _.find(sg.spaces, { id: spaceId })
    })
    return spaceGroup.type
  }

  renderDescription() {
    if (this.isNote()) {
      return "A note adds information to a space."
    } else {
      return "A placeholder reserves a space."
    }
  }

  renderDateInputs() {
    return (
      <div className="row form-row">
        <div className="col-xs-6">
          <FormGroup
            inputType="datepicker"
            name="start_date"
            label="Start"
            value={this.state.startDate && moment(this.state.startDate)}
            onChange={(date) =>
              this.setState({ startDate: moment(date, "MM/DD/YYYY") })
            }
            validation={this.validator.message(
              "start date",
              this.state.startDate,
              "required"
            )}
          />
        </div>
        <div className="col-xs-6">
          <FormGroup
            inputType="datepicker"
            name="end_date"
            label="End"
            startDate={this.state.startDate && moment(this.state.startDate)}
            value={this.state.endDate && moment(this.state.endDate)}
            onChange={(date) =>
              this.setState({ endDate: moment(date, "MM/DD/YYYY") })
            }
            validation={this.validator.message(
              "end date",
              this.state.endDate,
              "required"
            )}
          />
        </div>
      </div>
    )
  }

  renderSpaceDropdown() {
    return (
      <FormGroup
        inputType="select"
        label="Space"
        value={this.state.spaceId}
        name="space_id"
        onChange={this.spaceChange}
        validation={this.validator.message(
          "space",
          this.state.spaceId,
          "required"
        )}
      >
        <option value={null} />
        {this.spaceOptions()}
      </FormGroup>
    )
  }

  renderNoteInput() {
    return (
      <div className="space-y-4">
        {this.props.showFlagToggle && this.isNote() ? (
          <div className="flex items-center justify-between gap-3 rounded border border-gray-200 px-3 py-2">
            <span className="text-sm font-medium text-gray-700">
              Flag this note
            </span>
            <Toggle
              name="flag-this-note"
              checked={this.state.isFlagged}
              onChange={(event) =>
                this.setState({ isFlagged: event.target.checked })
              }
            />
          </div>
        ) : null}
        <FormGroup
          inputType="textarea"
          label="Text"
          name="note"
          value={this.state.note}
          onChange={this.handleInputChange}
          validation={this.validator.message(
            "text",
            this.noteValidationValue(),
            "required"
          )}
        />
      </div>
    )
  }

  renderLengthInput() {
    if (this.state.type === "placeholder") {
      const isTypeLoa = ["SpaceGroup::Linear", "SpaceGroup::LinearV2"].includes(
        this.state.spaceType
      )
      const validation = isTypeLoa
        ? this.validator.message(
            "length_overall",
            this.state.length_overall,
            "required|numeric|min:1,num|max:2000,num"
          )
        : this.state.length_overall
        ? this.validator.message(
            "length_overall",
            this.state.length_overall,
            "numeric|min:1,num|max:2000,num"
          )
        : null
      const labelAndDescription = (
        <div>
          LOA
          <div className="text-muted font-normal">
            Required for linear dock spaces.
          </div>
        </div>
      )

      return (
        <FormGroup
          inputType="feet"
          label={labelAndDescription}
          name="length_overall"
          value={this.state.length_overall}
          onChange={this.handleInputChange}
          validation={validation}
        />
      )
    }
  }

  render() {
    return (
      <div className="flex h-screen w-full flex-col justify-start">
        <div className="overflow-y-auto" style={{ paddingBottom: 170 }}>
          <div className="flex justify-between">
            <h4 className="bs-mt-2 font-semibold">
              <i
                className={
                  this.isNote()
                    ? "fa-kit bs-mr-3 fa-clipboard-pencil"
                    : "fa-solid bs-mr-3 fa-thumbtack"
                }
              />
              {capitalizeFirstLetter(this.state.type)}
            </h4>
          </div>
          <div className="text-muted bs-mb-4">{this.renderDescription()}</div>
          <div className="bg-light-gray bs-p-4">
            {this.renderDateInputs()}
            {this.renderSpaceDropdown()}
            {this.renderNoteInput()}
            {this.renderLengthInput()}
            {this.props.selectedPlaceholder.id && (
              <NextButton
                processing={this.state.deleting}
                click={this.deletePlaceholder}
                icon=""
                btnClass="btn btn-secondary w-full mt-4 mb-3 "
                text={`Delete ${this.isNote() ? "Note" : "Placeholder"}`}
                processingText="Deleting..."
              />
            )}
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 mt-auto border-t bg-white px-4 py-4 xl:sticky xl:-mb-4 xl:px-0">
          <NextButton
            processing={this.state.saving}
            click={this.savePlaceholder}
            icon=""
            btnClass="btn btn-primary w-full"
            text="Save"
            processingText="Saving..."
          />
        </div>
      </div>
    )
  }
}

PlaceholdersView.propTypes = {
  closeSidebar: PropTypes.func.isRequired,
  comingFromMapView: PropTypes.bool,
  reloadCurrentGrid: PropTypes.func.isRequired,
  selectedPlaceholder: PropTypes.object.isRequired,
  showFlagToggle: PropTypes.bool,
  spacesBySpaceGroups: PropTypes.array.isRequired,
}

export default PlaceholdersView
